// ----------------------------------------------------------------------------
// Component: Slim Banner
// ----------------------------------------------------------------------------

// -------------------------------------
// Dependencies
// -------------------------------------

import './_slim-banner.scss';